// extracted by mini-css-extract-plugin
module.exports = {"teamImage":"TheAthletePerformanceGif_teamImage_11CIu"};